import script from "./ScreenElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenElement.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenElement.vue?vue&type=style&index=0&id=2139723a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2139723a"]])

export default __exports__